// Words the public site and the league admin share (#1118): the
// sport-independent glossary. The sport packs' own words are in the
// sport-packs namespace. fr.ts / es.ts mirror them.

const en = {
  /**
   * League concepts that read the same in every sport (TERMINOLOGY.md §5, the
   * admin-v2 vocabulary). Base (title) casing; term() derives the others.
   * Sport-varying nouns (Game/Match, GP/MP, Court/Pitch) are the packs' (sport-packs).
   */
  glossary: {
    season: 'Season',
    seasons: 'Seasons',
    /** A set of games inside a season with one format (DB: tournaments). */
    competition: 'Competition',
    competitions: 'Competitions',
    format: 'Format',
    /** One round of a round-robin competition (the pack's `roundRobinRound` wins where a sport overrides it). */
    matchday: 'Matchday',
    round: 'Round',
    /** Games in a season that belong to no competition (admin-v2 wording). */
    regularSeason: 'Regular season',
    standings: 'Standings',
    /** The two sides of a game (not the Home page). */
    homeSide: 'Home',
    awaySide: 'Away',
    results: 'Results',
    /** Stat leaders. */
    leaders: 'Leaders',
    bracket: 'Bracket',
    liveEvent: 'Live Event',
    liveEvents: 'Live Events',
    ticketSale: 'Ticket sale',
    schedule: 'Schedule',
    /** A group of seasons inside one sport (Youth, Men's; #583). Fixed in v1, no per-league override (DECISIONS 9). */
    division: 'Division',
    divisions: 'Divisions',
    /** The switcher option that shows every division at once. */
    allDivisions: 'All divisions',
  },
}

export default en
